
import { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useRoutes } from 'react-router-dom';
import routes from './router/config';
import LoadingScreen from './components/base/LoadingScreen';

function AppRoutes() {
  return useRoutes(routes);
}

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  return (
    <>
      {isLoading && <LoadingScreen onComplete={handleLoadingComplete} />}
      <BrowserRouter basename={__BASE_PATH__}>
        <div className={`transition-opacity duration-500 ${isLoading ? 'opacity-0' : 'opacity-100'}`}>
          <AppRoutes />
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;
